import { getItemFromCollection } from "directus/src/operations";
import { apiRoot } from "services/src/config";

export async function fetchQuadDataforForm({ id, fields }) {
  try {
    const response = await getItemFromCollection(
      "performance_review_months",
      id,
    );
    return response;
  } catch (error) {
    console.error(error);

    throw error;
  }
}

export async function generateQuadData(quadId) {
  try {
    const params = {
      quadrimesterId: quadId,
    };
    const response = await apiRoot.post(
      `/performance-review/generate?quadrimesterId=${quadId}`,
    );
    return response?.data;
    // await new Promise((resolve) => setTimeout(resolve, 3000));
    // return null;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
